<template>
  <div>
    <b-container fluid class="login-wrapper d-flex align-items-center justify-content-center">
      <b-row no-gutters class="w-100" style="max-width: 600px;">
        <b-col cols="12">
          <div class="login-form px-4">
            <div class="mt-2">
              <div class="mb-5 login-logo">
                <img :src="logoHomeImg" alt="Logo" />
                <h4 class="text-right">Rápido, seguro y digital</h4>
              </div>
              <label class="lm-input-label">
                E-Mail
                <input
                  id="superuser-email"
                  type="email"
                  placeholder="tu@email.com"
                  class="lm-input"
                  :class="{ 'error': $v.form.email.$error }"
                  v-model.lazy="$v.form.email.$model"
                >
                <small class="lm-input-caption" v-if="$v.form.email.$error">Campo inválido</small>
              </label>
              <label class="lm-input-label" v-if="!forgotPasswordMode">
                Contraseña
                <input
                  id="superuser-password"
                  type="password"
                  placeholder="Tu contraseña"
                  class="lm-input"
                  :class="{ 'error': $v.form.password.$error }"
                  v-model.lazy="$v.form.password.$model"
                >
                <small class="lm-input-caption" v-if="$v.form.password.$error">Campo inválido</small>
              </label>

              <div class="d-flex align-items-end gap-3">
                <label class="lm-input-label flex-grow-1" v-if="!forgotPasswordMode">
                  Código
                  <input
                    type="text"
                    placeholder="Tu código"
                    class="lm-input"
                    :class="{ 'error': $v.form.token.$error }"
                    v-model="$v.form.token.$model"
                  >
                  <small class="lm-input-caption" v-if="$v.form.token.$error">Campo inválido</small>
                </label>

                <button
                  class="lm-button"
                  :disabled="loading || timer > 0"
                  @click="onSendToken"
                >
                  <template v-if="!loading && timer <= 0">
                    Enviar código
                  </template>
                  <template v-else-if="timer > 0">
                    Espera {{ timer }}s
                  </template>
                  <template v-else>
                    <i class="mdi mdi-loading lm-button-loading"></i>
                  </template>
                </button>
              </div>
              <div class="d-flex align-items-end gap-3 mt-2">
                <button
                  type="submit"
                  class="lm-button"
                  :disabled="loading || !form.token"
                  @click="login"
                >
                  <template v-if="!loading">
                    Ingresar
                  </template>
                  <template v-else>
                    <i class="mdi mdi-loading lm-button-loading"></i>
                  </template>
                </button>
              </div>
            </div>
            <img :src="logoLumileWhite" alt="Logo" width="80" class="mt-5">
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmPassword from '@/components/form/elements/LmPassword'
import store from '@/store'
import { mapState, mapGetters, mapActions } from 'vuex'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import lmToasts from '@/mixins/lmToasts.js'
import commonsApi from '@/api/commons'
import { generateRoutes } from '@/helpers/LmDynamicRoutes'

export default {
  name: 'Login',
  inject: ['lumbredocs_v3'],
  components: {
    LmTextInput,
    LmPassword,
    LmTreeSelect,
    LmButton
  },
  mixins: [lmToasts],
  data () {
    return {
      form: {
        email: '',
        customer: null,
        password: null,
        token: null
      },
      serverErrorMessage: '',
      loading: false,
      sentRestoreEmailSuccessfully: false,
      forgotPasswordMode: false,
      enableForgotPassword: process.env?.VUE_APP_ENABLE_FORGOT_PASSWORD === 'yes',
      errorUserOrPassword: false,
      timer: 0
    }
  },
  validations: {
    form: {
      email: {
        required: requiredIf(function (val) {
          return this.loginByEmail && val
        }),
        email
      },
      username: {
        required: requiredIf(function (val) {
          return !this.loginByEmail && val
        })
      },
      /* customer: {
        required
      }, */
      password: {
        required
      },
      token: {
        required
      }
    }
  },
  methods: {
    ...mapActions('notifications', ['getNotifications']),
    async onSendToken () {
      try {
        this.loading = true
        await commonsApi.axiosPostWrapper(
          '/users/send_token',
          { email: this.form.email }
        )
        this.timer = 30
        const interval = setInterval(() => {
          this.timer--
          if (this.timer <= 0) {
            clearInterval(interval)
          }
        }, 1000)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    login () {
      if (this.authMode === 'session') {
        this.$v.form.$touch()
        if (!this.$v.form.$pending && !this.$v.form.$error) {
          this.loading = true
          store.dispatch('session/login', this.form)
            .then(async _ => {
              if (process?.env?.VUE_APP_DYNAMIC_ROUTER === 'yes') {
                // Genero las rutas dinamicas para el usuario logueado
                const routes = await generateRoutes()
                // Inserto las rutas en la instancia de vue-router
                routes.forEach(route => {
                  this.$router.addRoute(route)
                })
              }
            })
            .then(_ => {
              // Busco los parámetros de la url para el "redirect"
              const params = new Proxy(new URLSearchParams(location.search), {
                get: (searchParams, prop) => searchParams.get(prop)
              })
              const urlToRedirect = params?.redirect || '/'
              this.$router.push(urlToRedirect)
              if (process.env.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes') {
                this.getNotifications()
              }
            })
            .catch(error => {
              // if (typeof error.response.data.message !== 'undefined') {
              //   this.serverErrorMessage = error.response.data.message
              //   console.log('error.response.data.message', error.response.data.message)
              // }
              console.log(error)
              // this.lmToastDangerMessage('Email o contraseña inválida.', 'Error')
              this.errorUserOrPassword = true
            })
            .finally(_ => {
              this.loading = false
            })
        }
      } else {
        store.dispatch('session/login', {})
      }
    },
    logout () {
      store.dispatch('session/logout')
    }
  },
  computed: {
    ...mapGetters('session', ['isAuthenticated']),
    ...mapState('settings', ['appName', 'logoHomeImg', 'title1', 'title2', 'text', 'bgImage', 'loginBgColor', 'loginLogoWidth', 'loginLogoJustifyContent', 'loginTextAlign', 'customerList', 'logoLumileWhite', 'loginH1Text']),
    authMode () {
      return process.env.VUE_APP_AUTH_MODE
    },
    loginByEmail () {
      if (process.env?.VUE_APP_SESSION_LOGIN_BY_EMAIL === 'yes') {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    if (this.isAuthenticated) {
      this.$router.replace('/')
    }
    this.form.customer = JSON.parse(localStorage.getItem('currentCustomer'))
  },
  mounted () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
.login-wrapper
  padding: 0
  height: 100vh
  background: rgb(255,21,99)
  background: linear-gradient(90deg, rgba(255,21,99,1) 0%, rgba(176,58,135,1) 100%)
  overflow: hidden

@keyframes spin
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

.login-logo
  width: 90%

.login-form
  color: white
  height: 100%

  .lm-button
    text-transform: uppercase
    background-color: white
    color: black
    border-radius: 20px
    border: none
    padding: 8px 20px
    font-weight: bold
    transition: all .4s ease-in-out
    &:disabled
      cursor: not-allowed
      background-color: rgba(232, 232, 232, .9)
    &:hover
      transform: scale(1.02)
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)
    .lm-button-loading::before
      font-weight: bold
      animation-name: spin
      animation-duration: 1000ms
      animation-iteration-count: infinite
      animation-timing-function: linear
  .lm-link
    display: inline
    background: transparent
    color: white
    border: none
    border-bottom: 1px solid rgba(255, 255, 255, .4)
  .lm-input-label
    font-weight: bold
    display: flex
    flex-direction: column
  .lm-input
    font-weight: bold
    margin-top: 2px
    height: 42px
    border: none
    border-radius: 20px
    padding: 0 20px
    color: black
    background-color: rgba(241, 241, 241, .5)
    transition: all .4s ease-in-out
    &:focus
      outline: none
      box-shadow: 0 0 0 0.25rem rgba(58, 66, 165, .4)
    &::placeholder
      color: #4F4F4F
    &.error
      box-shadow: 0 0 0 0.25rem rgba(197, 0, 0, .4)
  .lm-input-caption
    letter-spacing: .075rem
    font-size: .7rem
    padding: 6px 20px
    color: white

.login-background
  height: 100%
  background-color: white
  background-repeat: no-repeat
  background-attachment: fixed
  background-position: center
  background-size: 80%
  position: relative

.login-title
  width: 50%
  color: #3B43A6
  font-size: 2.6rem
  position: absolute
  top: 15%
  left: 5%

#wrapper-login
  background-position: center
  background-size: cover
  .col-left
    padding: 50px 55px
    width: 100%
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    .logoSite
      margin: 0 auto
      display: block
    h4
      font-size: 18px
      font-weight: 700
      color: $primaryFontThemeColor
    p
      color: $mutedFontThemeColor!important
      font-size: 14px
      font-weight: 400
</style>
